import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

export const EXPORT_OPTIONS = [
	{
		id: 1,
		labelKey: translationKey(
			'corgi.petition.starter_dashboard.engage_your_supporters.recent_supporters.export_options.signatures_csv',
		),
		value: 'SIGNATURES',
	},
	{
		id: 2,
		labelKey: translationKey(
			'corgi.petition.starter_dashboard.engage_your_supporters.recent_supporters.export_options.comments_csv',
		),
		value: 'COMMENTS',
	},
];

export type ExportErrorCode =
	| 'JOB_ALREADY_IN_PROGRESS'
	| 'MAINTENANCE'
	| 'UNAUTHORIZED'
	| 'GENERIC_ERROR'
	| 'PUBLISH_TOO_RECENT'
	| 'NO_DATA';
type ExportErrorType = { code: ExportErrorCode; message: TranslationKey };

export const EXPORT_ERROR_MAP: Record<ExportErrorCode, ExportErrorType> = {
	JOB_ALREADY_IN_PROGRESS: {
		code: 'JOB_ALREADY_IN_PROGRESS',
		message: translationKey(
			'corgi.petition.starter_dashboard.engage_your_supporters.recent_supporters.response_options.job_already_in_progress',
		),
	},
	MAINTENANCE: {
		code: 'MAINTENANCE',
		message: translationKey(
			'corgi.petition.starter_dashboard.engage_your_supporters.recent_supporters.response_options.maintenance',
		),
	},
	UNAUTHORIZED: {
		code: 'UNAUTHORIZED',
		message: translationKey(
			'corgi.petition.starter_dashboard.engage_your_supporters.recent_supporters.response_options.unauthorized',
		),
	},
	PUBLISH_TOO_RECENT: {
		code: 'PUBLISH_TOO_RECENT',
		message: translationKey(
			'corgi.petition.starter_dashboard.engage_your_supporters.recent_supporters.response_options.publish_too_recent',
		),
	},
	GENERIC_ERROR: {
		code: 'GENERIC_ERROR',
		message: translationKey(
			'corgi.petition.starter_dashboard.engage_your_supporters.recent_supporters.response_options.error',
		),
	},
	NO_DATA: {
		code: 'NO_DATA',
		message: translationKey('fe.errors.generic_no_data'),
	},
};

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const exportErrorCodes = Object.keys(EXPORT_ERROR_MAP) as ReadonlyArray<keyof typeof EXPORT_ERROR_MAP>;

export const EXPORT_SUCCESS_CODE = translationKey(
	'corgi.petition.starter_dashboard.engage_your_supporters.recent_supporters.response_options.success',
);
